import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events,LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { CarteraPage } from '../pages/cartera/cartera';
import { MovimientoCarteraPage } from '../pages/movimiento-cartera/movimiento-cartera';
import { LoginPage } from '../pages/login/login';
import { ComprobantesPage } from '../pages/comprobantes/comprobantes';
import {ConsolidadoPage} from '../pages/consolidado/consolidado';
import {MedidaPage} from '../pages/medida/medida';
import {DepartamentoPage} from '../pages/departamento/departamento';
import {EntidadPage} from '../pages/entidad/entidad'
import {CuentaTesoreriaPage} from '../pages/cuenta-tesoreria/cuenta-tesoreria'

import { MenuController } from 'ionic-angular';

import { AuthServiceProvider } from '../providers/auth-service/auth-service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  splitPaneState: boolean;
  rootPage: any;

  //pages: Array<{title: string, component: any, params:any, icon:string}> = null;
  pages:any;
  shownGroup:any;

  private wide: boolean = false;

  constructor(public platform: Platform, public statusBar: StatusBar, public loadingCtrl:LoadingController,
    public splashScreen: SplashScreen, public menuCtrl: MenuController,
    public authService : AuthServiceProvider, public events: Events,
    private translateService: TranslateService) {

   

    this.authService.checkAuthentication().then(val => {
      this.splitPaneState =true;
      this.rootPage = HomePage;
      this.initializeApp();
      //this.authService.getMenu(this.authService.usuario['idtusuario']).then(data => {
        //this.pages = data;
        //console.log(data);
      //});
      this.paginasUsuario(this.authService.usuario['idtusuario']);
    },(err) => {
      this.splitPaneState =false;
      this.rootPage = LoginPage;
      this.initializeApp();
      this.authService.logout();
    });

    events.subscribe('user:login', () => {
      this.paginasUsuario(this.authService.usuario['idtusuario']);
    });

    events.subscribe('user:validartoken', (error) => {
      this.validarToken(error);
    });
  }

  validarToken(error){
    if(~error.indexOf("token") && ~error.indexOf("expirado")){
      //console.log('token controlado expirado')
      this.showLoader("Su tiempo de sesión ha caducado, vuelva a iniciar sesión.", 2000);
      this.logout();
    }
  }

  showLoader(mensaje,tiempo){
    var loading = this.loadingCtrl.create({
        content: mensaje,
        duration: tiempo,
        spinner: 'hide'
    });

    loading.present();
    loading.onDidDismiss(() => { });
  }

  logout(){
    this.splitPaneState =false;
    this.rootPage = LoginPage;
    this.initializeApp();
    this.authService.logout();
    this.nav.setRoot(LoginPage);
    this.menuCtrl.close();

    setInterval(()=>{
      window.location.reload();
    },2500)
  }

  paginasUsuario(idtusuario){
    if(idtusuario == 1){
      this.pages = [
        { title: 'tab_home', component: HomePage, params:null, icon:'home' },
        { title: 'tab_receipt', component: ComprobantesPage, params:null, icon:'archive' }
      ];
    }
    else{
      /*this.pages = [
        { title: 'tab_home', component: HomePage, params:null, icon:'home' },
        { title: 'tab_deuda', component: CarteraPage, params:null, icon:'book' },
        { title: 'tab_pago', component: MovimientoCarteraPage, params:null, icon:'cash' },
        { title: 'tab_receipt', component: ComprobantesPage, params:null, icon:'archive' },
        { title: 'tab_consolidado' , component: ConsolidadoPage, params:null, icon:'archive'},
        { title: 'tab_medida' , component: MedidaPage, params:null, icon:'document'},
        { title: 'tab_dept' , component: DepartamentoPage, params:null, icon:'bookmarks'},
        { title: 'tab_operador' , component: EntidadPage, params:{'idtentidad':1}, icon:'contact'},
        { title: 'tab_cliente' , component: EntidadPage, params:{'idtentidad':2}, icon:'contacts'},
        { title: 'tab_proveedor' , component: EntidadPage, params:{'idtentidad':3}, icon:'contacts'},
        { title: 'tab_cuentat' , component: CuentaTesoreriaPage, params:null, icon:'card'}
      ];
    }*/

    this.pages = [
          {title: 'tab_home', component: HomePage, params:null, icon: 'home'},
          {
            title: 'tab_cartera', icon: 'list-box', right_icon: 'add',
            sub: [
              {sub_title: 'tab_deuda', component: CarteraPage, params:null, icon: 'book'},
              {sub_title: 'tab_pago', component: MovimientoCarteraPage, params:null, icon: 'cash'},
              {sub_title: 'tab_consolidado', component: ConsolidadoPage, params:null, icon: 'archive'}
            ]
          },
          {title: 'tab_receipt', component: ComprobantesPage, params:null, icon: 'cloud-done'},
          {
            title: 'tab_configuracion', icon: 'albums', right_icon: 'add',
            sub: [
              {sub_title: 'tab_operador', component: EntidadPage, params:{'idtentidad':1}, icon: 'contact'},
              {sub_title: 'tab_dept', component: DepartamentoPage, params:null, icon: 'bookmarks'},
              {sub_title: 'tab_cliente' , component: EntidadPage, params:{'idtentidad':2}, icon: 'contact'},
              {sub_title: 'tab_proveedor' , component: EntidadPage, params:{'idtentidad':3}, icon: 'contact'}
            ]
          },
          {title: 'tab_cuentat', component: CuentaTesoreriaPage, params:null, icon: 'card'}
        ];
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.translateService.setDefaultLang('en');
      this.translateService.use('en');

      this.statusBar.styleDefault();
      this.splashScreen.hide();

      //this.setWidth();
      //this.listenToEvents();
    });
  }

  setWidth() {
    if (this.platform.width() > 767) {
        this.wide = true;
        this.menuCtrl.open();
    } else {
        this.wide = false;
        this.menuCtrl.close();
    }
  };

  listenToEvents() {
      window.addEventListener('resize', () => {
          this.setWidth(); 
      });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    //this.nav.setRoot(page.component, page.params);
    if(!(page.component)){
      this.showChild(page);
    }else{
      this.shownGroup = null;
      this.nav.setRoot(page.component, page.params);
      this.menuCtrl.close();
    }
  }

  showChild(page){
    if (this.isSubmenuShown(page)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = page;
    }
  }

  isSubmenuShown(page){
    return this.shownGroup === page;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts